import { render, staticRenderFns } from "./VNotSuccess.vue?vue&type=template&id=d0ba673c&"
import script from "./VNotSuccess.vue?vue&type=script&lang=js&"
export * from "./VNotSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports